// Файл toast_message.js

/**
 * Модуль обслуживает сценарий `toast_message` в разделе `Toast`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

const primitive_message = (value) => {
    if (typeof value === 'string') {
        return value.trim();
    }

    if (typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
    }

    return '';
};


export const dispatch_toast_event = (value) => {
    if (!value || typeof value !== 'object') {
        return false;
    }

    const event_name = primitive_message(value.driver_panel_event);

    if (!event_name || typeof window === 'undefined') {
        return false;
    }

    window.dispatchEvent(new CustomEvent(
        event_name,
        { detail: value.payload || {} },
    ));

    return value.silent === true;
};


export const normalize_toast_message = (value) => {
    const direct_message = primitive_message(value);

    if (direct_message) {
        return direct_message;
    }

    const candidates = [
        value?.response?.data?.response,
        value?.response?.data?.message,
        value?.response?.data?.error,
        value?.data?.response,
        value?.data?.message,
        value?.data?.error,
        value?.response,
        value?.message,
        value?.error,
    ];

    for (const candidate of candidates) {
        const message = primitive_message(candidate);

        if (message) {
            return message;
        }
    }

    if (value instanceof Error) {
        return value.message || 'Произошла ошибка';
    }

    return 'Произошла ошибка';
};
